<template>
  <div v-if="$store.state.responsive.viewDesktopFilters" id="product-filters">
    <!-- Contenido del formulario desktop -->
    <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
      <div class="row">
        <!-- Contenido de los filtros -->
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="brand">Marca</label>
            <VueNextSelect class="form-control generalInput" id="brand" :options="brandsData || []" v-model.trim="brand"
                           @click="selectBrand(brand)" close-on-select placeholder="" aria-labelledby="Marca" />
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="model">Modelo</label>
            <VueNextSelect class="form-control generalInput" id="model" :options="modelsData" v-model.trim="model"
                           @click="selectModel(model)" close-on-select placeholder="" aria-labelledby="Modelo" />
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="capacity">Capacidad</label>
            <VueNextSelect class="form-control generalInput" id="capacity" :options="capacitiesData"
                           v-model.trim="capacity" @click="selectCapacity(capacity)" close-on-select placeholder=""
                           aria-labelledby="Capacidad" />
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="color">Color</label>
            <VueNextSelect class="form-control generalInput" id="color" :options="colorsData" v-model.trim="color"
                           close-on-select placeholder="" aria-labelledby="Color" />
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="price">Precio</label>
            <VueNextSelect class="form-control generalInput" id="price"
                           :options="['0€-25€', '26€-50€', '51€-65€', '65€+']" v-model.trim="price" close-on-select placeholder=""
                           aria-labelledby="Price" />
          </div>
        </div>
        <div class="col-12 col-lg-3 pt-2">
          <div class="form-group mt-5">
            <div class="custom-control custom-checkbox" style="z-index:0">
              <input type="checkbox" class="custom-control-input" id="stock" v-model.trim="stock" />
              <label class="custom-control-label labelCheck" for="stock">Mostrar solo stock disponible</label>
            </div>
          </div>
        </div>
        <!-- Botones -->
        <div class="col-12 col-lg-6 justify-content-end align-items-end align-content-end botones">
          <div class="d-flex justify-content-end align-items-end align-content-end">
            <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
            <button class="btn btn-primary generalPrimaryButton" :disabled="isSearching">
              <span v-if="isSearching" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span v-else>Buscar</span>
            </button>
          </div>
        </div>
        <div class="col-12 col-lg-12 justify-content-end align-items-end align-content-end botones"
             v-if="$store.state.roles.Backoffice_member_empresas && $route.name != 'productos' && $store.state.newContractData.product.length > 0">
          <div class="d-flex justify-content-end align-items-end align-content-end">
            <button class="btn generalTertiaryButton" @click="openProductModal">Continuar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div v-else>
    <!-- Vista móvil -->
    <div class="filterHeader link-primary d-flex align-items-center justify-content-between" data-toggle="collapse"
         href="#filterCollapse" role="button" aria-expanded="false" aria-controls="filterCollapse">
      <p class="m-0">FILTROS</p>
      <v-icon name="bi-filter" scale="1.5" />
    </div>
    <hr/>
    <div class="collapse" id="filterCollapse">
      <!-- Contenido del formulario móvil - misma estructura que desktop -->
      <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
        <!-- ... mismos filtros que en desktop ... -->
      </form>
    </div>
  </div>

  <SelectedProducts
      ref="selectedProductsModal"
      :id="'selectedProducts'"
      :modalTitle="'PRODUCTOS AÑADIDOS'"
      :class="'modal-lg'"
      :showFooter="false"
      :tab=2
      v-if="modalProducts"
      @closeModal="closeModal"
  />
</template>

<script>
import axios from 'axios';
import VueNextSelect from 'vue-next-select';
import SelectedProducts from "../Contracts/NewContract/SelectedProducts/SelectedProducts.vue";
import {Modal as ModalBootstrap} from "bootstrap";
import eventBus from "./eventBus.js";

export default {
  name: 'ProductFilters',
  components: {
    SelectedProducts,
    VueNextSelect
  },
  data() {
    return {
      isSearching: false,
      modalProducts: false,
      modalInstance: null,
      brand: '',
      model: '',
      capacity: '',
      color: '',
      stock: false,
      price: '',
      brandsData: [],
      modelsData: [],
      capacitiesData: [],
      colorsData: [],
    };
  },
  computed: {
    filtersApplied() {
      return {
        brand: this.brand || '',
        model: this.model || '',
        capacity: this.capacity || '',
        color: this.color || '',
        stock: this.stock,
        priceFrom: (this.price && this.price.replaceAll('€', '').replaceAll('+', '').split('-')[0]) || '',
        priceTo: (this.price && this.price.includes('+')) || this.price === '' ? '' : this.price.replaceAll('€', '').split('-')[1],
      };
    },
  },
  created() {
    this.loadBrandsData();
  },
  mounted() {
    if (!Array.isArray(this.productsAux) || this.productsAux.length === 0) {
      this.isLoading = true;
    }
  },
  beforeUnmount() {
    if (this.modalInstance) {
      this.modalInstance.dispose();
    }
    eventBus.off("productsLoaded");
  },
  methods: {
    filter() {
      if (!this.brandsData || !Array.isArray(this.brandsData) || this.brandsData.length === 0) {
        console.error('No brands data available');
        return;
      }
      this.isSearching = true;

      // Removemos listener previo para evitar duplicados
      eventBus.off("productsLoaded");
      eventBus.off("productsError");
      
      // Timeout solo para casos de error real
      let timeoutId = null;
      
      // Listener para carga exitosa
      eventBus.on("productsLoaded", () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        this.isSearching = false;
      });

      // Listener para errores
      eventBus.on("productsError", () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        this.isSearching = false;
      });

      // Iniciamos el timeout después de emitir el evento
      this.$emit("filter", this.filtersApplied);
      
      // Solo configuramos el timeout si no hay respuesta después de 3 segundos
      timeoutId = setTimeout(() => {
        if (this.isSearching) {
          console.error('La búsqueda tardó demasiado o hubo un error');
          this.isSearching = false;
        }
      }, 3000);
    },
    loadBrandsData() {
      axios.get(`/products/brands`)
          .then((response) => {
            this.brandsData = Array.isArray(response.data) ? response.data : [];
          })
          .catch((error) => {
            console.error("Error loading brands:", error);
          });
    },
    loadModelsData(idBrand) {
      if (!idBrand) return;
      axios.get(`/products/models-by-brand?brand=${idBrand}`)
          .then((response) => {
            this.modelsData = Array.isArray(response.data) ? response.data : [];
          });
    },
    loadCapacitiesData(idBrand, idModel) {
      if (!idBrand || !idModel) return;
      axios.get(`/products/capacities?brand=${idBrand}&model=${encodeURIComponent(idModel)}`)
          .then((response) => {
            this.capacitiesData = Array.isArray(response.data) ? response.data : [];
          });
    },
    loadColorsData(idBrand, idModel, idCapacity) {
      if (!idBrand || !idModel || !idCapacity) return;
      axios.get(`/products/colors?brand=${idBrand}&model=${encodeURIComponent(idModel)}&capacity=${idCapacity}`)
          .then((response) => {
            this.colorsData = Array.isArray(response.data) ? response.data : [];
          });
    },
    selectBrand(idBrand) {
      this.modelsData = [];
      this.capacitiesData = [];
      this.colorsData = [];
      this.model = '';
      this.capacity = '';
      this.color = '';
      if (idBrand !== '') {
        this.loadModelsData(idBrand);
      }
    },
    selectModel(idModel) {
      this.capacitiesData = [];
      this.colorsData = [];
      this.capacity = '';
      this.color = '';
      if (idModel !== '') {
        this.loadCapacitiesData(this.brand, idModel);
      }
    },
    selectCapacity(idCapacity) {
      this.colorsData = [];
      this.color = '';
      if (idCapacity !== '') {
        this.loadColorsData(this.brand, this.model, idCapacity);
      }
    },
    cleanSearch() {
      this.brand = '';
      this.model = '';
      this.capacity = '';
      this.color = '';
      this.stock = false;
      this.price = '';
      this.modelsData = [];
      this.capacitiesData = [];
      this.colorsData = [];
      this.isSearching = false;
    },
    enterKey(e) {
      if (e.keyCode === 13) {
        this.filter();
        if (this.capacity !== '') {
          this.loadColorsData(this.brand, this.model, this.capacity);
        } else if (this.model !== '') {
          this.loadCapacitiesData(this.brand, this.model);
        } else if (this.brand !== '') {
          this.loadModelsData(this.brand);
        }
      }
    },
    openProductModal() {
      // Limpiar modal existente
      if (this.modalInstance) {
        this.modalInstance.dispose();
        this.modalInstance = null;
      }

      // Limpiar backdrop existente
      const existingBackdrop = document.querySelector('.modal-backdrop');
      if (existingBackdrop) {
        existingBackdrop.remove();
      }
      document.body.classList.remove('modal-open');

      this.modalProducts = true;

      this.$nextTick(() => {
        const modalElement = document.getElementById("selectedProducts");
        if (!modalElement) return;

        this.modalInstance = new ModalBootstrap(modalElement);

        // Manejar cierre del modal
        modalElement.addEventListener('hidden.bs.modal', () => {
          const backdrop = document.querySelector('.modal-backdrop');
          if (backdrop) {
            backdrop.remove();
          }
          document.body.classList.remove('modal-open');
          if (this.modalInstance) {
            this.modalInstance.dispose();
            this.modalInstance = null;
          }
          this.modalProducts = false;
        }, {once: true});

        // Manejar navegación al continuar
        const continueBtn = modalElement.querySelector('.generalTertiaryButton');
        if (continueBtn) {
          continueBtn.addEventListener('click', () => {
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) {
              backdrop.remove();
            }
            document.body.classList.remove('modal-open');
            if (this.modalInstance) {
              this.modalInstance.dispose();
              this.modalInstance = null;
            }
          }, {once: true});
        }

        this.modalInstance.show();
      });
    },
    closeModal() {
      if (this.modalInstance) {
        // Asegurar que el elemento existe antes de cerrar
        const modalElement = document.getElementById("selectedProducts");
        if (modalElement) {
          this.modalInstance.hide();
          // Esperar a que termine la animación
          modalElement.addEventListener('hidden.bs.modal', () => {
            this.modalInstance.dispose();
            this.modalInstance = null;
            this.modalProducts = false;
          }, {once: true});
        } else {
          this.modalInstance = null;
          this.modalProducts = false;
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../scss/variables.scss';

.filterHeader {
  font-size: 1.143rem;
  line-height: 1.5;
}

.link-primary {
  color: $primary;
  cursor: pointer;

  &:hover {
    color: $primary-hover;
  }
}

.botones {
  display: flex;
  vertical-align: middle;
}

.spinner-border {
  width: 1rem;
  height: 1rem;
  border-width: 0.15em;
  color: white;
}
</style>